import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#468EF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.602 11.694C12.296 11.974 11.905 12.114 11.428 12.114C10.838 12.114 10.374 11.925 10.037 11.547C9.699 11.166 9.53 10.645 9.53 9.983C9.53 9.267 9.722 8.715 10.106 8.327C10.44 7.99 10.865 7.821 11.381 7.821C12.071 7.821 12.575 8.047 12.894 8.5C13.07 8.754 13.165 9.009 13.178 9.265H12.321C12.265 9.068 12.194 8.92 12.107 8.82C11.951 8.642 11.72 8.553 11.414 8.553C11.102 8.553 10.857 8.679 10.677 8.931C10.497 9.182 10.407 9.537 10.407 9.997C10.407 10.457 10.501 10.802 10.691 11.032C10.882 11.26 11.124 11.374 11.417 11.374C11.717 11.374 11.946 11.276 12.104 11.079C12.191 10.973 12.264 10.815 12.321 10.603H13.17C13.095 11.05 12.906 11.414 12.602 11.694Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.031 12.114C6.444 12.114 5.997 11.955 5.687 11.636C5.271 11.244 5.064 10.68 5.064 9.944C5.064 9.193 5.271 8.629 5.687 8.252C5.997 7.933 6.444 7.774 7.031 7.774C7.617 7.774 8.065 7.933 8.374 8.252C8.788 8.629 8.995 9.193 8.995 9.944C8.995 10.68 8.788 11.244 8.374 11.636C8.065 11.955 7.617 12.114 7.031 12.114ZM7.84 11.012C8.039 10.762 8.138 10.406 8.138 9.944C8.138 9.484 8.038 9.129 7.837 8.878C7.639 8.626 7.37 8.5 7.031 8.5C6.691 8.5 6.42 8.625 6.218 8.876C6.016 9.126 5.915 9.482 5.915 9.944C5.915 10.406 6.016 10.762 6.218 11.012C6.42 11.263 6.691 11.388 7.031 11.388C7.37 11.388 7.64 11.263 7.84 11.012Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.809 12H1.042V7.899H2.809C3.063 7.903 3.274 7.932 3.443 7.988C3.73 8.083 3.963 8.256 4.141 8.508C4.284 8.712 4.382 8.933 4.433 9.17C4.485 9.408 4.511 9.634 4.511 9.849C4.511 10.395 4.402 10.857 4.183 11.235C3.886 11.745 3.428 12 2.809 12ZM3.446 8.945C3.314 8.723 3.053 8.611 2.664 8.611H1.874V11.288H2.664C3.068 11.288 3.35 11.088 3.51 10.69C3.597 10.471 3.64 10.21 3.64 9.908C3.64 9.49 3.576 9.17 3.446 8.945Z",
			fill: "white"
		})
	]
});
export default SvgDoc;
